/*
 * @Author: 刘怡
 * @Date: 2022-04-12 09:45:28
 * @Last Modified by: 刘怡
 * @Last Modified time: 2022-04-12 09:46:11
 */
import request from '@/utils/request';
/**
 * 理赔列表
 * @param {*} data
 * @returns
 */
export function documentResource(data) {
  return request.post('admin/claims-document/resource', data);
}
// 索赔文件-列表
export function claimsDocumentList(data) {
  return request.post('admin/claims-document/list', data);
}
// 索赔文件-新增
export function claimsDocumentAdd(data) {
  return request.post('admin/claims-document/store', data);
}

// 索赔文件-编辑
export function claimsDocumentEdit(data) {
  return request.post('admin/claims-document/edit', data);
}
// 索赔文件-删除
export function claimsDocumentDelete(data) {
  return request.post('admin/claims-document/delete', data);
}

// 索赔文件-详情
export function claimsDocumentDetail(data) {
  return request.post('admin/claims-document/detail', data);
}

// 索赔文件-状态更新
export function claimsDocumentUpdate(data) {
  return request.post('admin/claims-document/update', data);
}